<template>
  <LvStateSort
    :title="title"
    :list="list"
    :titleKey="titleKey"
    :labelKey="labelKey"
    @change="$_onChange($event)"
  >
    <template v-if="$scopedSlots.titleRight" v-slot:titleRight>
      <slot name="titleRight" />
    </template>
    <template v-if="$scopedSlots.right" v-slot:right="{ item }">
      <slot name="right" :item="item" />
    </template>
  </LvStateSort>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    list: {
      type: Array,
    },
    titleKey: {
      type: String,
      default: 'name',
    },
    labelKey: {
      type: String,
    },
  },
  methods: {
    $_onChange($event) {
      this.$emit('change', $event);
    },
  },
};
</script>
